/**
 * Skeleton spécifique pour les StatCards de TransactionsList
 * Adapté au design avec couleurs de fond
 */
const StatCardsSkeleton = () => {
  const colors = ['#e67e22', '#27ae60', '#8e44ad', '#c0392b'];

  return (
    <div className="row g-3 mb-4">
      {colors.map((color, i) => (
        <div className="col-6 col-lg-3" key={i}>
          <div 
            className="card counter h-100 border-0 shadow-sm position-relative overflow-hidden"
            style={{
              backgroundColor: color,
              borderRadius: '10px',
              minHeight: '140px',
              opacity: 0.85
            }}
          >
            <div className="card-body text-white p-3 position-relative">
              {/* Icon + Badge */}
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div className="placeholder-glow">
                  <div 
                    className="placeholder bg-white"
                    style={{ 
                      width: '40px',
                      height: '40px',
                      borderRadius: '8px',
                      opacity: 0.2
                    }}
                  ></div>
                </div>
                <div className="placeholder-glow">
                  <span 
                    className="placeholder bg-white rounded-pill"
                    style={{ 
                      width: '60px', 
                      height: '20px',
                      opacity: 0.25
                    }}
                  ></span>
                </div>
              </div>
              
              {/* Title + Value */}
              <div className="chart-num">
                <div className="placeholder-glow mb-2">
                  <span 
                    className="placeholder bg-white d-block rounded"
                    style={{ 
                      width: '70%', 
                      height: '12px',
                      opacity: 0.4
                    }}
                  ></span>
                </div>
                <div className="placeholder-glow">
                  <span 
                    className="placeholder bg-white d-block rounded"
                    style={{ 
                      width: '50%', 
                      height: '20px',
                      opacity: 0.5
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <style>{`
        @keyframes placeholder-glow {
          50% { opacity: 0.3; }
        }

        .placeholder {
          animation: placeholder-glow 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default StatCardsSkeleton;